<template>
  <div class="letter-container">
    <div class="letter">
      <div class="top-decoration"></div>
      <h6 class="letter-heading">{{ order.created_at | fullDate }}</h6>
      <div class="letter-content">
        <div>
          <p class="text-2xl">
            {{ mediaText }}
          </p>
        </div>

        <div v-if="mediaImages.length > 0" class="mt-2 d-flex flex-wrap">
          <b-img
            v-for="(image, index) in mediaImages"
            :key="index"
            :src="image.url"
            class="mb-2 mr-2 h-auto"
            style="width: 200px; object-fit: cover"
            :alt="image.name"
          ></b-img>
        </div>

        <div v-if="mediaVideos.length > 0" class="mt-2 d-flex flex-wrap">
          <video
            v-for="(video, index) in mediaVideos"
            :key="'video-' + index"
            :src="video.url"
            class="mb-2 me-1 w-100"
            controls
          ></video>
        </div>

        <div v-if="mediaAudios.length > 0" clas="mt-2 d-flex flex-wrap">
          <audio
            v-for="(audio, index) in mediaAudios"
            :key="'audio-' + index"
            :src="audio.url"
            class="mb-2 me-1 w-100"
            controls
          >

          </audio>
        </div>

        <div class="signature-container">
          <p class="signature-line">Atte</p>
          <p class="signature">{{ order.customer_name }}</p>
        </div>
      </div>
      <div class="bottom-decoration"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"

export default {
  components: {
  },
  data() {
    return {
      order: {},
      imgIndex: null,
    }
  },
  mounted() {
    this.fetchHiddenOrder(this.$route.params.id).then((response) => {
      this.order = response
    })
  },
  computed: {
    mediaText() {
      return (
        this.order?.multimedia_attributes?.filter(
          (media) => media.media_type === "text"
        )[0]?.content || ""
      )
    },
    mediaImages() {
      return (
        this.order?.multimedia_attributes?.filter(
          (media) => media.media_type === "image"
        ) || []
      )
    },
    mediaVideos() {
      const audios =
        this.order?.multimedia_attributes?.filter(
          (media) => media.media_type === "video"
        ) || []

      this.audioProgress = new Array(audios.length).fill({
        duration: 0,
        currentTime: 0,
        isPlaying: false,
      })

      return audios
    },
    mediaAudios() {
      const audios =
        this.order?.multimedia_attributes?.filter(
          (media) => media.media_type === "audio"
        ) || []

      return audios
    },
  },
  methods: {
    ...mapActions("orders", ["fetchHiddenOrder"]),
    ...mapActions("landingPage", ["setCurrentUser"]),
  },
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:ital@0;1&family=Dancing+Script&display=swap");

.letter-container {
  background-color: #f8f7f3;

  background-image: radial-gradient(#d9d9d9 0.5px, transparent 0.5px),
    radial-gradient(#d9d9d9 0.5px, #f8f7f3 0.5px);
  background-size: 14px 14px;
  background-position: 0 0, 7px 7px;

  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), 0 0 40px rgba(0, 0, 0, 0.05) inset;
}

.letter-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f5f5;
}

.letter-container::before {
  background: repeating-linear-gradient(
    90deg,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0) 2px,
    rgba(0, 0, 0, 0.01) 2px,
    rgba(0, 0, 0, 0.01) 4px
  );
  opacity: 0.3;
}

.image-preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
}

.image-preview-item {
  height: 150px;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.letter {
  position: relative;
  width: 100%;
  max-width: 800px;
  min-height: 800px;
  padding: 60px 40px;
  font-family: "Playfair Display", serif;
  line-height: 1.6;
  color: #333;
  overflow: hidden;

  background-color: #f8f7f3;

  background-image: radial-gradient(#d9d9d9 0.5px, transparent 0.5px),
    radial-gradient(#d9d9d9 0.5px, #f8f7f3 0.5px);
  background-size: 14px 14px;
  background-position: 0 0, 7px 7px;
}

.letter::before,
.letter::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.letter::before {
  background: repeating-linear-gradient(
    90deg,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0) 2px,
    rgba(0, 0, 0, 0.01) 2px,
    rgba(0, 0, 0, 0.01) 4px
  );
  opacity: 0.3;
}

.letter::after {
  background: repeating-linear-gradient(
    0deg,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0) 2px,
    rgba(0, 0, 0, 0.01) 2px,
    rgba(0, 0, 0, 0.01) 4px
  );
  opacity: 0.3;

  background-color: rgba(255, 253, 240, 0.1);
}

.top-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 180px;
  height: 180px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M20,50 Q40,20 60,40 T90,30" fill="none" stroke="%23d8a76b" stroke-width="2"/><circle cx="30" cy="40" r="10" fill="%23f3c397"/><circle cx="50" cy="30" r="8" fill="%23b19cd9"/><circle cx="70" cy="45" r="12" fill="%23f3c397"/><path d="M25,60 Q35,50 45,60 T65,50" fill="none" stroke="%23789f8a" stroke-width="2"/><path d="M20,70 Q30,60 40,70 T60,60" fill="none" stroke="%23789f8a" stroke-width="2"/></svg>');
  background-repeat: no-repeat;
  opacity: 0.8;
  transform: rotate(-10deg);
}

.bottom-decoration {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-top: 200px;
  width: 200px;
  height: 200px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M10,50 Q30,30 50,50 T90,30" fill="none" stroke="%23789f8a" stroke-width="2"/><circle cx="20" cy="40" r="8" fill="%23b19cd9"/><circle cx="40" cy="50" r="10" fill="%23f3c397"/><circle cx="60" cy="30" r="12" fill="%23f3c397"/><circle cx="80" cy="45" r="8" fill="%23b19cd9"/><path d="M15,70 Q25,60 35,70 T55,60" fill="none" stroke="%23789f8a" stroke-width="2"/></svg>');
  background-repeat: no-repeat;
  opacity: 0.8;
  transform: rotate(10deg);
}

.letter-heading {
  font-family: "Dancing Script", cursive;
  font-size: 1rem;
  text-align: right;
  margin-bottom: 2rem;
  color: #333;
  font-weight: normal;
}

.letter-content {
  font-size: 0.95rem;
  text-align: justify;
  margin-bottom: 2rem;
  margin-top: 8rem;
  position: relative;
  z-index: 1;
}

.signature-container {
  margin-top: 3rem;
  text-align: center;
  padding-right: 2rem;
}

.signature-line {
  margin-bottom: 0.5rem;
  font-style: italic;
}

.signature {
  font-family: "Dancing Script", cursive;
  font-size: 2rem;
  margin-top: 0.5rem;
}

@media (max-width: 768px) {
  .letter {
    padding: 40px 20px;
  }

  .letter-heading {
    font-size: 2rem;
  }

  .top-decoration,
  .bottom-decoration {
    width: 120px;
    height: 120px;
  }
}
</style>
